import React from 'react'
import PropTypes from 'prop-types'
import { ArrowDownward } from '@material-ui/icons'
import { ArrowDownScroll } from '../style'
import { useDevices } from '@gojiraf/responsive'

export const ScrollToBottom = ({ onClick, isMessageListScrolledToBottom }) => {
  const { isDesktop } = useDevices()

  return (
    <ArrowDownScroll
      onClick={onClick}
      hidden={isMessageListScrolledToBottom}
      isDesktop={isDesktop}
      size={isDesktop ? 'medium' : 'small'}
      color="secondary"
    >
      <ArrowDownward />
    </ArrowDownScroll>
  )
}

ScrollToBottom.propTypes = {
  onClick: PropTypes.func,
  isMessageListScrolledToBottom: PropTypes.bool,
}
